import React, { useState, useRef } from 'react';
import './edit-work-report.css';
import { MdEditDocument } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import { Button, Form } from 'react-bootstrap'; // Importing Form and Button from React Bootstrap
import JoditEditor from 'jodit-react'; // Importing JoditEditor for rich text editing

export default function EditWorkReport() {
  const editor = useRef(null); // Reference for JoditEditor
  const [report, setReport] = useState(''); // State to hold the report content

  // Configuration for JoditEditor (optional, can be customized)
  const config = {
    readonly: false, // Allow editing
    height: 400,
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle the form submission here (e.g., save report)
    console.log('Updated report:', report);
  };

  return (
    <>
      <h1 className='edit-report-title'><MdEditDocument /> Work Report of Anonymous</h1>
      <hr/>
      <div className='handbook-content'>
        <Form onSubmit={handleSubmit}>
          <div className="mb-3">
            <Form.Label htmlFor="reportEditor" className="form-label">
            <p  >Work Report date :mm/dd/yyyy<br/>
            Work Report Time:
                </p> 


             <h4> Work Report:</h4>
            </Form.Label>
            <JoditEditor
              ref={editor}
              value={report}
              config={config}
              tabIndex={1} // TabIndex of textarea
              onBlur={newContent => setReport(newContent)} // Update state on blur
              className="editor" // Added class for styling
            />
          </div>
          <div className="form-actions">
            <Button
              variant='primary'
              type="submit"
              className="fancy-button"
            >
              <FaEdit className="icon" />
              Update
            </Button>
          </div>
        </Form>
      </div>
    </>
  );
}
